import {css} from 'lit';

export const tagOnDarkStyles = css`
    --_tag__bg-color: var(--sbkTagColorBgColorOnDarkEnabled);
    --_tag__fgColor-enabled: var(--sbkTagColorFgColorOnDarkEnabled);
    --_tag__fgColor-hover: var(--sbkTagColorFgColorOnDarkHover);
    --_tag__fgColor-active: var(--sbkTagColorFgColorOnDarkActive);
    --_tag__fgColor-selected: var(--sbkTagColorFgColorOnDarkSelected);
    --_tag__border-focus: var(--sbkTagBorderOnDarkFocus);
`
